import React from "react";
import { Link } from "react-router-dom";
import { GoHome } from "react-icons/go";

export default function HomeLinkComponent() {
  return (
    <Link to="/" className="flex item-center justify-center f-w-b f-s-30 f-s">
      <GoHome />
    </Link>
  );
}
